import { GhostButton } from '@ardoq/button';
import { Stack, FlexBox } from '@ardoq/layout';
import { PanelFooter } from 'appLayout/ardoqStudio/saveAsViewpoint/atoms';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { t } from '@ardoq/i18n';

const Footer = ({ onCancel }: { onCancel: VoidFunction }) => {
  // i18nLocale$.state OK here: used for a static "Cancel" label in a footer button
  const i18nLocale = i18nLocale$.state;
  return (
    <PanelFooter padding="medium" justify="end">
      <Stack align="flex-end">
        <FlexBox gap="medium" align="flex-end">
          <GhostButton onClick={onCancel}>
            {t(i18nLocale, 'canvas:cancelButtonLabel', 'Cancel')}
          </GhostButton>
        </FlexBox>
      </Stack>
    </PanelFooter>
  );
};

export { Footer };
